
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 6853 973","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fcc802"}},[_c('circle',{attrs:{"cx":"486.488","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"1662.45","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"2838.41","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"4014.38","cy":"486.488","r":"486.488"}})]),_c('path',{attrs:{"d":"M4069.28 476.888c51.6 16.8 77.4 51.6 77.4 104.4 0 25.2-6.3 47.1-18.9 65.7-12.6 18.6-29.8 32.9-51.6 42.9s-46.5 15-74.1 15c-41.2 0-81.2-10.6-120-31.8l13.8-52.8c18.8 10.8 36.5 19 53.1 24.6 16.6 5.6 34.5 8.4 53.7 8.4 25.6 0 45.9-6.4 60.9-19.2 15-12.8 22.5-29.8 22.5-51 0-24-8.3-42.8-24.9-56.4-16.6-13.6-41.3-20.4-74.1-20.4h-26.4v-51.6h26.4c26 0 46.5-6.1 61.5-18.3 15-12.2 22.5-28.9 22.5-50.1 0-22.4-5.7-39.1-17.1-50.1-11.4-11-28.1-16.5-50.1-16.5-16 0-31.2 3-45.6 9-14.4 6-29.6 14.4-45.6 25.2l-9.6-58.2c32.4-18.4 68.6-27.6 108.6-27.6 38.4 0 68.3 10.2 89.7 30.6 21.4 20.4 32.1 47.2 32.1 80.4 0 22.8-5.6 42.7-16.8 59.7-11.2 17-27 29.7-47.4 38.1z","fill":"#fff","fill-rule":"nonzero"}}),_c('g',{attrs:{"fill":"#0b0c0f"}},[_c('circle',{attrs:{"cx":"5190.34","cy":"486.488","r":"486.488"}}),_c('circle',{attrs:{"cx":"6366.3","cy":"486.488","r":"486.488"}})])])
          )
        }
      }
    